/**
 * SSE removed — Workers can't hold a Postgres LISTEN socket. The frontend
 * now uses react-query polling (see useInbox / useThread refetchInterval).
 *
 * This stub keeps the previous import surface so useAuth's `streamClient.setJwt`
 * calls remain harmless no-ops without forcing edits across the codebase.
 */
export const streamClient = {
  setJwt(_jwt: string | null): void {
    /* no-op: polling doesn't need an authenticated long-lived connection */
  },
};
